import { Link, useNavigate, useLocation } from "react-router-dom";
import "./NavbarFooter.css";

function Navbar() {

  const navigate = useNavigate();
  const location = useLocation();

  /* ---------------- CHECK CURRENT PAGE ---------------- */

  const isTempleListPage =
    location.pathname === "/temples";

  /* ---------------- GET USER ---------------- */

  const user =
    JSON.parse(
      localStorage.getItem("user")
    );

  /* ---------------- LOGOUT ---------------- */

  const handleLogout = () => {

    localStorage.removeItem("user");
    localStorage.removeItem("token");

    navigate("/login");

    window.location.reload();

  };

  return (

    <nav className="navbar navbar-expand-lg navbar-dark custom-navbar">

      <div className="container-fluid align-items-center">

        {/* ---------------- LOGO ---------------- */}

        <span className="navbar-brand fw-bold text-white d-flex flex-column">

          <span className="d-flex align-items-center">

            <span className="fs-3 me-2">
              🛕
            </span>

            DARSHANIKA

          </span>

          <span
            style={{
              fontSize: "11px",
              marginLeft: "50px",
              letterSpacing: "3px",
              color: "#e6e6e6",
              fontWeight: "300"
            }}
          >
            THE TEMPLE DIRECTORY
          </span>

        </span>

        {/* ---------------- TOGGLE ---------------- */}

        <button
          className="navbar-toggler"
          data-bs-toggle="collapse"
          data-bs-target="#menu"
        >
          ☰
        </button>

        {/* ---------------- NAVIGATION ---------------- */}

        <div
          className="collapse navbar-collapse"
          id="menu"
        >

          <ul className="navbar-nav ms-auto align-items-lg-center">

            {/* Home */}
            <li className="nav-item">
              <Link
                className={`nav-link fw-semibold nav-item-custom ${location.pathname === "/"
                  ? "active-tab"
                  : ""
                  }`}
                to="/"
              >
                Home
              </Link>
            </li>

            {/* Temple List */}
            <li className="nav-item">
              <Link
                className={`nav-link fw-semibold nav-item-custom ${location.pathname === "/temples"
                  ? "active-tab"
                  : ""
                  }`}
                to="/temples"
              >
                Temple List
              </Link>
            </li>

            {/* Plan Visit */}
            <li className="nav-item">
              <Link
                className={`nav-link fw-semibold nav-item-custom ${location.pathname === "/plan"
                  ? "active-tab"
                  : ""
                  }`}
                to="/plan"
              >
                Plan Visit
              </Link>
            </li>

            {/* Gallery */}
            <li className="nav-item">
              <Link
                className={`nav-link fw-semibold nav-item-custom ${location.pathname === "/gallery"
                  ? "active-tab"
                  : ""
                  }`}
                to="/gallery"
              >
                Gallery
              </Link>
            </li>

            {/* FAQ */}
            <li className="nav-item">
              <Link
                className={`nav-link fw-semibold nav-item-custom ${location.pathname === "/faq"
                  ? "active-tab"
                  : ""
                  }`}
                to="/faq"
              >
                FAQ
              </Link>
            </li>

            {/* About */}
            <li className="nav-item">
              <Link
                className={`nav-link fw-semibold nav-item-custom ${location.pathname === "/about"
                  ? "active-tab"
                  : ""
                  }`}
                to="/about"
              >
                About
              </Link>
            </li>

            {/* ---------------- USER AUTH ---------------- */}

            {/* {!user && ( */}

            {/* <> */}
            {/* Login */}
            {/* <li className="nav-item">
                  <Link
                    className={`nav-link fw-semibold nav-item-custom ${
                      location.pathname === "/login"
                        ? "active-tab"
                        : ""
                    }`}
                    to="/login"
                  >
                    Login
                  </Link>
                </li> */}

            {/* Signup */}
            {/* <li className="nav-item">
                  <Link
                    className={`nav-link fw-semibold nav-item-custom ${
                      location.pathname === "/signup"
                        ? "active-tab"
                        : ""
                    }`}
                    to="/signup"
                  >
                    Signup
                  </Link>
                </li>

              </> */}

            {/* )} */}

          </ul>

        </div>

        {/* ---------------- SEARCH BUTTON ---------------- */}

        {!isTempleListPage && (

          <button
            className="btn btn-light btn-sm mx-2 fw-normal d-flex align-items-center"
            style={{
              width: "200px"
            }}
            onClick={() =>
              navigate("/temples")
            }
          >

            <i className="bi bi-search me-1"></i>

            Search Temples

          </button>

        )}

        {/* ---------------- LANGUAGE ---------------- */}

        <select
          className="form-select form-select-sm w-auto mx-0"
          defaultValue=""
        >

          <option
            value=""
            disabled
            hidden
          >
            English
          </option>

          <option value="en">
            English
          </option>

          <option value="hi">
            हिंदी
          </option>

          <option value="mr">
            मराठी
          </option>

        </select>

        {/*  USER RIGHT END */}

        {user && (

          <div className="d-flex align-items-center">

            <span className="fw- text-light me-2">
              👤 {user.name}
            </span>

            <button
              className="btn btn-danger btn-sm"
              onClick={handleLogout}
            >
              Logout
            </button>

          </div>

        )}

      </div>

    </nav>

  );

}

export default Navbar;